import React, { Component } from "react";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
import Apps_BannerTitle from "../layouts/apps/Apps_BannerTitle";
import CityXTour_Sidebar from "../layouts/apps/cityx-tour/CityXTour_Sidebar";
import CityXTourGuides_SiteContent from "../layouts/apps/cityx-tour/CityXTourGuides_SiteContent";

class CityXTourGuides extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "../assets/img/logo-small.png",
          names: "Services",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/apps",
          titlelink: "Aplikacije",
          border: "|",
          name: "CityX Tour&Pass",
          heading: "CityX Tour&Pass",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-left header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <Apps_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <CityXTourGuides_SiteContent />
                <CityXTour_Sidebar />
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CityXTourGuides;
